<script>
    import ApiWidget from './ApiWidget';

    export default {
        extends: ApiWidget,
        props: [
            'default'
        ],

        data() {
            return {
                options: [],
                value: this.default,
            }
        },

        methods: {
            async update(data) {
                if (data.display === 'none') {
                    return this.$el.closest('.page-widget').hidden = true;
                }

                this.options = data.items;
                this.setValue();
            },

            setValue() {
                let setFromUrl = false;
                let setFromOptions = false;

                if (this.parameter) {
                    const urlSearchParameters = new URLSearchParams(window.location.search);

                    if (urlSearchParameters.has(this.parameter)) {
                        this.default = urlSearchParameters.get(this.parameter);
                        setFromUrl = true;
                    }
                }

                if (! setFromUrl) {
                    this.options.forEach(option => {
                        if (option.selected) {
                            this.value = option.id;
                            setFromOptions = true;
                        }
                    });

                    if (! setFromOptions && this.iteration === 1 && this.default) {
                        this.value = this.default;
                    }
                }

                this.broadcast(this.value);
            },

            updateValue(event, value = null) {
                event.preventDefault();
                this.broadcast(value ? value : event.target.value);
            }
        }
    }
</script>
